<app-table [data]="partNumbers"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [rowExpand]="false"
           [rowDuplicate]="!readOnly"
           [isMaterial]="false"
           [hasTitle]="hasTitle"
           [headerBackgroundColor]="headerBackgroundColor"
           title="{{'admin.partNumbers.table.title' | translate}}"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)"
           (duplicateClick)="onDuplicate($event)"
           (rowClick)="onRowClick($event)">
    <app-table-column header="{{'admin.partNumbers.table.columns.id' | translate}}"
                      filterPlaceholder="{{'admin.partNumbers.table.filter.placeholder.id' | translate}}"
                      filter="true"
                      sortable="true"
                      field="id">
        <ng-template #body
                     let-record="rowData">
            <span [class.not-configured]="!isConfigured(record)">{{ record?.id }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.partNumbers.table.columns.name' | translate}}"
                      filterPlaceholder="{{'admin.partNumbers.table.filter.placeholder.name' | translate}}"
                      filter="true"
                      sortable="true"
                      field="name">
        <ng-template #body
                     let-record="rowData">
            <span [class.not-configured]="!isConfigured(record)">{{ record?.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.partNumbers.table.columns.SAPFamily' | translate}}"
                      filterPlaceholder="{{'admin.partNumbers.table.filter.placeholder.SAPFamily' | translate}}"
                      filter="true"
                      sortable="true"
                      field="sapFamily">
        <ng-template #body
                     let-record="rowData">
            <span
                [class.not-configured]="!isConfigured(record)">{{ record?.sapFamily ? record?.sapFamily : 'N/A' }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.partNumbers.table.columns.SAPGroup' | translate}}"
                      filterPlaceholder="{{'admin.partNumbers.table.filter.placeholder.SAPGroup' | translate}}"
                      filter="true"
                      sortable="true"
                      field="sapGroup">
        <ng-template #body
                     let-record="rowData">
            <span
                [class.not-configured]="!isConfigured(record)">{{ record?.sapGroup ? record?.sapGroup : 'N/A' }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.partNumbers.table.columns.valueStream' | translate}}"
                      filterPlaceholder="{{'admin.partNumbers.table.filter.placeholder.valueStream' | translate}}"
                      filter="true"
                      sortable="true"
                      field="valueStream">
        <ng-template #body
                     let-record="rowData">
            <span
                [class.not-configured]="!isConfigured(record)">{{ record?.valueStream ? record?.valueStream : 'N/A' }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.partNumbers.table.columns.type' | translate}}"
                      filterPlaceholder="{{'admin.partNumbers.table.filter.placeholder.type' | translate}}"
                      filter="true"
                      sortable="true"
                      field="type">
        <ng-template #body
                     let-record="rowData">
            <span [class.not-configured]="!isConfigured(record)">{{ record?.type ? record?.type : 'N/A' }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.partNumbers.table.columns.ECAM' | translate}}"
                      filterPlaceholder="{{'admin.partNumbers.table.filter.placeholder.ECAM' | translate}}"
                      filter="true"
                      sortable="true"
                      field="ecam">
        <ng-template #body
                     let-record="rowData">
            <span [class.not-configured]="!isConfigured(record)">{{ record?.ecam ? record?.ecam : 'N/A' }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.partNumbers.table.columns.ECAMVersion' | translate}}"
                      filterPlaceholder="{{'admin.partNumbers.table.filter.placeholder.ECAMVersion' | translate}}"
                      filter="true"
                      sortable="true"
                      field="ecamVersion">
        <ng-template #body
                     let-record="rowData">
            <span
                [class.not-configured]="!isConfigured(record)">{{ record?.ecamVersion ? record?.ecamVersion : 'N/A' }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.partNumbers.table.columns.BOMStatus' | translate}}"
                      filterPlaceholder="{{'admin.partNumbers.table.filter.placeholder.BOMStatus' | translate}}"
                      filter="true"
                      sortable="true"
                      field="bomStatus">
        <ng-template #body
                     let-record="rowData">
            <span
                [class.not-configured]="!isConfigured(record)">{{ record?.bomStatus ? record?.bomStatus : 'N/A' }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.partNumbers.table.columns.status.title' | translate}}"
                      field="status">

        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="statusFilters"
                          valueField="value"
                          displayField="name"
                          emptyText="{{'admin.partNumbers.table.filter.placeholder.status' | translate}}"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
        <ng-template #body
                     let-record="rowData">
            <span
                [class.not-configured]="!isConfigured(record)">{{ ('admin.partNumbers.table.columns.status.' + record.status) | translate }} </span>
        </ng-template>
    </app-table-column>
</app-table>

<!--<app-table [data]="partNumbers"-->
<!--           [config]="tableConfig"-->
<!--           [isLoading]="isLoading"-->
<!--           [rowExpand]="false"-->
<!--           [rowDuplicate]="true"-->
<!--           [headerBackgroundColor]="headerBackgroundColor"-->
<!--           title="{{'admin.equipment.table.title' | translate}}"-->
<!--           (sortChange)="onSortChange($event)"-->
<!--           (filterChange)="onFilterChange($event)"-->
<!--           (pageChange)="onPageChange($event)"-->
<!--           (duplicateClick)="onDuplicate($event)"-->
<!--           (rowClick)="onRowClick($event)">-->
<!--    <app-table-column header="{{'admin.partNumbers.table.columns.id' | translate}}"-->
<!--                      filterPlaceholder="{{'admin.partNumbers.table.filter.placeholder.id' | translate}}"-->
<!--                      filter="true"-->
<!--                      sortable="true"-->
<!--                      field="id">-->
<!--        <ng-template #body-->
<!--                     let-record="rowData">-->
<!--            <span [class.not-configured]="!isConfigured(record)">{{ record?.id }}</span>-->
<!--        </ng-template>-->
<!--    </app-table-column>-->
<!--    <app-table-column header="{{'admin.partNumbers.table.columns.name' | translate}}"-->
<!--                      filterPlaceholder="{{'admin.partNumbers.table.filter.placeholder.name' | translate}}"-->
<!--                      filter="true"-->
<!--                      sortable="true"-->
<!--                      field="name">-->
<!--        <ng-template #body-->
<!--                     let-record="rowData">-->
<!--            <span [class.not-configured]="!isConfigured(record)">{{ record?.name }}</span>-->
<!--        </ng-template>-->
<!--    </app-table-column>-->
<!--    <app-table-column header="{{'admin.partNumbers.table.columns.SAPFamily' | translate}}"-->
<!--                      filterPlaceholder="{{'admin.partNumbers.table.filter.placeholder.SAPFamily' | translate}}"-->
<!--                      filter="true"-->
<!--                      sortable="true"-->
<!--                      field="sapFamily">-->
<!--        <ng-template #body-->
<!--                     let-record="rowData">-->
<!--            <span [class.not-configured]="!isConfigured(record)">{{ record?.sapFamily ? record?.sapFamily : 'N/A' }}</span>-->
<!--        </ng-template>-->
<!--    </app-table-column>-->
<!--    <app-table-column header="{{'admin.partNumbers.table.columns.SAPGroup' | translate}}"-->
<!--                      filterPlaceholder="{{'admin.partNumbers.table.filter.placeholder.SAPGroup' | translate}}"-->
<!--                      filter="true"-->
<!--                      sortable="true"-->
<!--                      field="sapGroup">-->
<!--        <ng-template #body-->
<!--                     let-record="rowData">-->
<!--            <span [class.not-configured]="!isConfigured(record)">{{ record?.sapGroup ? record?.sapGroup : 'N/A' }}</span>-->
<!--        </ng-template>-->
<!--    </app-table-column>-->
<!--    <app-table-column header="{{'admin.partNumbers.table.columns.valueStream' | translate}}"-->
<!--                      filterPlaceholder="{{'admin.partNumbers.table.filter.placeholder.valueStream' | translate}}"-->
<!--                      filter="true"-->
<!--                      sortable="true"-->
<!--                      field="valueStream">-->
<!--        <ng-template #body-->
<!--                     let-record="rowData">-->
<!--            <span [class.not-configured]="!isConfigured(record)">{{ record?.valueStream ? record?.valueStream : 'N/A' }}</span>-->
<!--        </ng-template>-->
<!--    </app-table-column>-->
<!--    <app-table-column header="{{'admin.partNumbers.table.columns.type' | translate}}"-->
<!--                      filterPlaceholder="{{'admin.partNumbers.table.filter.placeholder.type' | translate}}"-->
<!--                      filter="true"-->
<!--                      sortable="true"-->
<!--                      field="type">-->
<!--        <ng-template #body-->
<!--                     let-record="rowData">-->
<!--            <span [class.not-configured]="!isConfigured(record)">{{ record?.type ? record?.type : 'N/A' }}</span>-->
<!--        </ng-template>-->
<!--    </app-table-column>-->
<!--    <app-table-column header="{{'admin.partNumbers.table.columns.ECAM' | translate}}"-->
<!--                      filterPlaceholder="{{'admin.partNumbers.table.filter.placeholder.ECAM' | translate}}"-->
<!--                      filter="true"-->
<!--                      sortable="true"-->
<!--                      field="ecam">-->
<!--        <ng-template #body-->
<!--                     let-record="rowData">-->
<!--            <span [class.not-configured]="!isConfigured(record)">{{ record?.ecam ? record?.ecam : 'N/A' }}</span>-->
<!--        </ng-template>-->
<!--    </app-table-column>-->
<!--    <app-table-column header="{{'admin.partNumbers.table.columns.ECAMVersion' | translate}}"-->
<!--                      filterPlaceholder="{{'admin.partNumbers.table.filter.placeholder.ECAMVersion' | translate}}"-->
<!--                      filter="true"-->
<!--                      sortable="true"-->
<!--                      field="ecamVersion">-->
<!--        <ng-template #body-->
<!--                     let-record="rowData">-->
<!--            <span [class.not-configured]="!isConfigured(record)">{{ record?.ecamVersion ? record?.ecamVersion : 'N/A' }}</span>-->
<!--        </ng-template>-->
<!--    </app-table-column>-->
<!--    <app-table-column header="{{'admin.partNumbers.table.columns.status.title' | translate}}"-->
<!--                      field="status">-->

<!--        <ng-template #filter-->
<!--                     let-column="column"-->
<!--                     let-table="table">-->
<!--            <app-dropdown [(ngModel)]="column.filterValue"-->
<!--                          [items]="statusFilters"-->
<!--                          valueField="value"-->
<!--                          displayField="name"-->
<!--                          emptyText="{{'admin.partNumbers.table.filter.placeholder.status' | translate}}"-->
<!--                          (selectItem)="table.onFilterChange(column)"></app-dropdown>-->
<!--        </ng-template>-->
<!--        <ng-template #body-->
<!--                     let-record="rowData">-->
<!--            <span [class.not-configured]="!isConfigured(record)">{{('admin.partNumbers.table.columns.status.' + record.status) | translate}} </span>-->
<!--        </ng-template>-->
<!--    </app-table-column>-->
<!--</app-table>-->
